/** ****************************************************************************
Functionality for warning banners that appear at the top of the site.
Example banners are not having JS turned on, and to upgrade to a modern
browser.
Banner html is available in htm/banners.
Additional banners can be added by duplicating the banner HTML and applying
a new unique data-warning-banner id. The JS below will pick it up
automatically.

*******************************************************************************/
import $ from 'jquery';

const warningBanners = {
  init() {
    const self = this;
    const $banners = $('[data-warning-banner]');

    $banners.each(function () {
      self.create_banner($(this));
    });
  },

  create_banner($banner) {
    const bannerId = $banner.attr('data-warning-banner');
    const storageKey = `${bannerId}_banner_closed_by_user`;

    // show banner if the user has not closed perviously - banners are
    // hidden by default
    if (localStorage.getItem(storageKey) !== 'true') {
      $banner.removeClass('is-hidden');
    }

    // on clicking close bt hide the banner and update local storage
    $banner.find('.js-warning-close').on('click', () => {
      $banner.slideUp(300, () => {
        $banner.addClass('is-hidden');
        localStorage.setItem(storageKey, 'true');
      });
    });
  },
};

export default warningBanners;
